<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Phân công giáo viên phụ trách&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
        nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
        <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
      </button>
        <button class="flex items-center justify-center text-green-600" nz-button nzTooltipTitle="Thêm"
          nzTooltipPlacement="bottom" nz-tooltip (click)="Add()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
        <button class="flex items-center justify-center text-red-600" nz-button nzTooltipTitle="Xóa"
          nzTooltipPlacement="bottom" nz-tooltip (click)="deleteMulti()">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
        nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
       Xuất Excel
      </button>
        <button class="flex items-center justify-center" nz-button (click)="Add()">Thêm
        </button>
        <button class="flex items-center justify-center text-red-600" nz-button nzTooltipTitle="Xóa"
          nzTooltipPlacement="bottom" nz-tooltip (click)="deleteMulti()">
          Xóa
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
        nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
        <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        Xuất Excel
      </button>
        <button class="flex items-center justify-center" nz-button (click)="Add()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
          Thêm
        </button>
        <button class="flex items-center justify-center text-red-600" nz-button nzTooltipTitle="Xóa"
          nzTooltipPlacement="bottom" nz-tooltip (click)="deleteMulti()">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
          Xóa
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete [ascModel]="provinceControl" (ascModelChange)="changeProvince($event)"
            [placeholder]="'Chọn tỉnh thành'" [getListAC]="getProvinceACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Cơ sở</nz-form-label>
          <asc-autocomplete [ascModel]="schoolControl" (ascModelChange)="changeSchool($event)"
            [placeholder]="'Chọn cơ sở'" [getListAC]="getSchoolACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Loại khuyết tật</nz-form-label>
          <asc-autocomplete [ascModel]="typeOfDisabilitysControl" (ascModelChange)="changeTypeOfDisabilitys($event)"
            [placeholder]="'Chọn loại khuyết tật'" [getListAC]="getTypeOfDisabilitysACFn"></asc-autocomplete>
        </nz-form-item>
      </div>



      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Loại nhân sự</nz-form-label>
          <asc-autocomplete [ascModel]="typeOfPersonnelControl" (ascModelChange)="changeTypeOfPersonnel($event)"
            [placeholder]="'Chọn loại nhân sự'" [getListAC]="getTypeOfPersonnelACFn"></asc-autocomplete>
        </nz-form-item>
      </div>



      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS">Mã giáo viên</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="commonFilter.StaffCode" [ngModelOptions]="{standalone: true}" type="text"
              placeholder="Nhập mã giáo viên">
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS">Họ tên</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="commonFilter.FullName" [ngModelOptions]="{standalone: true}" type="text"
              placeholder="Nhập tên">
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Giới tính:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
              <label nz-radio [nzValue]="1">Nam</label>
              <label nz-radio [nzValue]="0">Nữ</label>
              <label nz-radio nzValue="">Tất cả</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>


    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip>Xóa tìm kiếm</button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button> 
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
           
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search"
            nzTheme="outline"></i>Tìm kiếm</button>
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
       
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table  nzOuterBordered nzShowSizeChanger [nzData]="systemuserList" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full" [nzFrontPagination]="false"
      [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)"
      (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzLeft nzWidth="50px" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"></th>
          <th nzWidth="50px" nzLeft [nzSortFn]="sortNameFn" [nzSortDirections]="'ascend'">STT</th>
          <th >Tên giáo viên</th>
          <th >Loại khuyết tật</th>
          <th nzAlign="center">Quản lý người khuyết tật</th>
          <th nzAlign="center">Danh sách người khuyết tật</th>
          <th nzRight nzWidth="100px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft [nzChecked]="setOfCheckedId.has(data.id)" (nzCheckedChange)="onItemChecked(data.id, $event)"></td>
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td>{{data.fullName}}</td>
          <td>{{data.typeOfDisabilityName}}</td> 
          <td nzAlign="center"> <a class="text-blue-600" nzTooltipTitle="Danh sách quản lý người khuyết tật" nzTooltipPlacement="top"
              nz-tooltip (click)="viewManageSchool(data)">
              <span style="font-size: 14px;"><strong >{{data.studentNumber}}</strong> </span>
            </a></td>
          <td nzAlign="center"> <a class="text-blue-600" nzTooltipTitle="Chọn người khuyết tật" nzTooltipPlacement="top"
              nz-tooltip (click)="addSchool(data)">
              <i nz-icon nzType="user" nzTheme="outline"></i></a></td>
          <td nzRight>
            <div nz-space nzAlign="end" class="space-align-block">
              <nz-space-item>
                <a class="text-blue-600" nzTooltipTitle="Sửa" nzTooltipPlacement="top" nz-tooltip
                  (click)="Edit(data)">
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </a>
              </nz-space-item>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
<ng-template #tplTitle>
  <div class="flex justify-between">
    <span>{{ titlePopup }}</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>